<template>
  <div>
    <b-row class="text-center container m-auto">
      <b-col lg="12">
        <h2>
          <strong
            >Przystąp do testu końcowego<br />
            i zyskaj Certyfikat obsługi programu SKP<sup>®</sup></strong
          >
        </h2>
      </b-col>
      <b-col lg="7" class="text-left pl-lg-5 pt-lg-4 font-size-14">
        <ul class="list-group list-group-flush bg-transparent">
          <b>Poznaj ZASADY:</b>
          <li
            class="list-group-item bg-transparent d-flex flex-row align-middle"
          >
            <div class="float-left my-auto mr-2">
              <b-icon-caret-right-fill
                class="text-info"
              ></b-icon-caret-right-fill>
            </div>
            <p class="my-auto">
              Ten Certyfikowany test został przygotowany przez naszych ekspertów
              z dziedziny księgowości;
            </p>
          </li>
          <li
            class="list-group-item bg-transparent d-flex flex-row align-middle"
          >
            <div class="float-left my-auto mr-2">
              <b-icon-caret-right-fill
                class="text-info"
              ></b-icon-caret-right-fill>
            </div>
            <p class="my-auto">
              Test jest całkowicie
              <b>BEZPŁATNY</b> i dostępny jedynie dla Użytkowników programu
              SKP®;
            </p>
          </li>
          <li
            class="list-group-item bg-transparent d-flex flex-row align-middle"
          >
            <div class="float-left my-auto mr-2">
              <b-icon-caret-right-fill
                class="text-info"
              ></b-icon-caret-right-fill>
            </div>
            <p class="my-auto">
              Test składa się z <b>40 pytań</b> (jednokrotnego lub wielokrotnego
              wyboru) lub zadań do rozwiązania;
            </p>
          </li>
          <li
            class="list-group-item bg-transparent d-flex flex-row align-middle"
          >
            <div class="float-left my-auto mr-2">
              <b-icon-caret-right-fill
                class="text-info"
              ></b-icon-caret-right-fill>
            </div>
            <p class="my-auto">
              Po rozpoczęciu testu algorytm wylosuje dla Ciebie
              <b>40 z puli 200</b>
              pytań;
            </p>
          </li>
          <li
            class="list-group-item bg-transparent d-flex flex-row align-middle"
          >
            <div class="float-left my-auto mr-2">
              <b-icon-caret-right-fill
                class="text-info"
              ></b-icon-caret-right-fill>
            </div>
            <p class="my-auto">
              Dostaniesz <b>20 minut</b> na przejście testu;
            </p>
          </li>
          <li
            class="list-group-item bg-transparent d-flex flex-row align-middle"
          >
            <div class="float-left my-auto mr-2">
              <b-icon-caret-right-fill
                class="text-info"
              ></b-icon-caret-right-fill>
            </div>
            <p class="my-auto">
              Po ukończeniu testu otrzymasz podsumowanie oraz informację o
              zaliczeniu lub niepowodzeniu;
            </p>
          </li>
          <li
            class="list-group-item bg-transparent d-flex flex-row align-middle"
          >
            <div class="float-left my-auto mr-2">
              <b-icon-caret-right-fill
                class="text-info"
              ></b-icon-caret-right-fill>
            </div>
            <p class="my-auto">
              Udzielenie min. 60%, czyli
              <span class="font-weight-bold"
                >24 poprawnych odpowiedzi na pytania</span
              >
              uprawnia Cię do pobrania imiennego Certyfikatu z obsługi programu
              SKP® (wersja elektroniczna w formacie PDF);
            </p>
          </li>
          <li
            class="list-group-item bg-transparent d-flex flex-row align-middle"
          >
            <div class="float-left my-auto mr-2">
              <b-icon-caret-right-fill
                class="text-info"
              ></b-icon-caret-right-fill>
            </div>
            <p class="my-auto">
              Test możesz wykonać dowolną ilość razy, aż do uzyskania
              pozytywnego wyniku;
            </p>
          </li>
          <li
            class="list-group-item bg-transparent d-flex flex-row align-middle"
          >
            <div class="float-left my-auto mr-2">
              <b-icon-caret-right-fill
                class="text-info"
              ></b-icon-caret-right-fill>
            </div>
            <p class="my-auto">
              Certyfikat potwierdzi zdobyte przez Ciebie umiejętności
              samodzielnej obsługi programu SKP®.
            </p>
          </li>
        </ul>
      </b-col>
      <b-col lg="5">
        <div
          class="
            bg-white
            h-auto
            mb-auto
            mt-5
            mx-5
            border
            rounded-lg
            p-5
            d-flex
            flex-column
          "
        >
          <b-img
            class="mt-1 mb-5 img-fluid"
            :src="styles.course_test_xl"
            fluid
          ></b-img>
          <b-button
            v-on:click="onToggleExamInfo"
            class="m-auto py-4 max-w-75 font-size-22 btn-accept-color"
            >Zaczynamy <b-icon-chevron-right class="font-size-22 mb-1"
          /></b-button>
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-3 text-right">
      <b-col lg="12"> </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CourseExamInfo',
  data() {
    return {};
  },
  props: {
    styles: {},
    examResults: {},
    participantName: {},
  },
  created() {},
  computed: {
    ...mapGetters({
      licence: 'auth/userLicence',
    }),
  },
  methods: {
    onToggleExamInfo() {
      window.dataLayer.push({
        event: 'btnZaczynamy',
        license_id: this.licence,
      });

      this.$emit('onToggleExamInfo', false);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
}
</style>
